<template>
    <router-link :to="to" v-if="to">
        <div :class="`btn btn-${variant}`">
            <div :class="`btn-${variant}__text`">
                <slot name="text"></slot>
            </div>
            <div :class="`btn-${variant}__icon`">
                <slot name="icon"></slot>
            </div>
        </div>
    </router-link>
    <a :href="href" target="_blank" v-else>
        <div :class="`btn btn-${variant}`">
            <div :class="`btn-${variant}__text`">
                <slot name="text"></slot>
            </div>
            <div :class="`btn-${variant}__icon`">
                <slot name="icon"></slot>
            </div>
        </div>
    </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'Button',
    props: {
        variant: String,
        to: String,
        href: String,
    },
})
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins';
@import '../../styles/config';

.btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: $font-family-header;
    margin: 0;

    @include mQ(550px) {
        font-size: 0.85rem;
    }

    &-primary,
    &-ghost,
    &-facebook,
    &-linkedin {
        padding: 0.3rem;
        border-radius: 50px;
        font-weight: 300;
        transition: background-color 250ms ease-in;
    }

    &-primary {
        background-color: $accent-color;

        &:hover {
            background-color: darken($accent-color, 5%);
        }
    }

    &-ghost {
        background-color: #fff;

        &:hover {
            background-color: darken(#fff, 3%);
        }
    }

    &-facebook {
        background-color: $facebook-color;

        &:hover {
            background-color: darken($facebook-color, 5%);
        }
    }

    &-linkedin {
        background-color: $linkedin-color;

        &:hover {
            background-color: darken($linkedin-color, 5%);
        }
    }

    &-primary__icon,
    &-facebook__icon,
    &-linkedin__icon,
    &-ghost__icon {
        flex-basis: content;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50px;
        margin-left: 0.5rem;
        min-height: 40px;
        min-width: 40px;
    }

    &-primary__text,
    &-ghost__text,
    &-facebook__text,
    &-linkedin__text {
        width: calc(100% - (40px + 1rem));
        text-align: center;
        margin-left: 1rem;
    }

    &-primary__text,
    &-facebook__text,
    &-linkedin__text {
        color: #fff;
    }

    &-ghost__text {
        color: $accent-color;
    }

    &-primary__icon {
        background-color: #fff;
    }

    &-facebook__icon {
        background-color: $facebook-color;
    }

    &-linkedin__icon {
        background-color: $linkedin-color;
    }

    &-ghost__icon {
        background-color: $accent-color-very-light;
    }
}
</style>
